<div class="modal">
    <div class="header">
        <div class="title title-medium" translate>MODAL_RELOGIN_TITLE</div>
        <span class="error-message" *ngIf="!(processing$ | async) && !(succeeded$ | async) && !(submitted && f.password.errors) && (errorMessageKey$ | async) as errorMessageKey">{{ errorMessageKey | translate }}</span>
    </div>
    <div class="body">
        <!-- Processing: re-authentication in flight. -->
        <div class="section section-centered" *ngIf="processing$ | async">
            <div class="loading-spinner-grey"></div>
        </div>
        <!-- Success: explicit acknowledgement before the modal auto-closes. -->
        <div class="section section-centered" *ngIf="succeeded$ | async">
            <span class="description success-message" translate>MODAL_RELOGIN_SUCCESS</span>
        </div>
        <!-- Form: initial state and the state we return to after a retryable failure. -->
        <div class="section" *ngIf="!(processing$ | async) && !(succeeded$ | async)">
            <span class="description" translate [translateParams]="{ username: username }">MODAL_RELOGIN_DESCRIPTION</span>
            <form class="form-section" [formGroup]="reloginForm" (ngSubmit)="onSubmit()">
                <div class="form-input">
                    <app-smash-input borderStyle="full" type="password" formControlName="password"
                        placeholder="{{ 'MODAL_RELOGIN_PASSWORD_PLACEHOLDER' | translate }}">
                    </app-smash-input>
                    <span class="error-message" *ngIf="submitted && f.password.errors">{{ 'MODAL_RELOGIN_ERROR_EMPTY_PASSWORD' | translate }}</span>
                </div>
            </form>
        </div>
    </div>
    <div class="footer">
        <ng-container *ngIf="!(succeeded$ | async)">
            <button class="btn-new white" type="button" (click)="abort()" translate [disabled]="(processing$ | async)">MODAL_RELOGIN_SIGN_OUT</button>
            <button class="btn-new red" type="submit" (click)="onSubmit()" translate [disabled]="(processing$ | async)">MODAL_RELOGIN_CONFIRM</button>
        </ng-container>
        <button class="btn-new red" type="button" *ngIf="succeeded$ | async" (click)="close()" translate>MODAL_RELOGIN_CLOSE</button>
    </div>
</div>
